import { react2angular } from 'react2angular';
import CountryName from './index';

export const CountryNameModule = angular
  .module('app.components.countryName', [])
  .component('countryName', react2angular(CountryName))
  .name;



// WEBPACK FOOTER //
// ./src/app/admin/components/CountryName/index.ng.js